'use strict';

var EventEmitter = require('events');

var Stat = require('./stat');

var OldPeers = require('./old-peers');

var defaultOptions = {
  computeThrottleMaxQueueSize: 1000,
  computeThrottleTimeout: 2000,
  movingAverageIntervals: [60 * 1000, // 1 minute
  5 * 60 * 1000, // 5 minutes
  15 * 60 * 1000 // 15 minutes
  ],
  maxOldPeersRetention: 50
};
var initialCounters = ['dataReceived', 'dataSent'];
var directionToEvent = {
  in: 'dataReceived',
  out: 'dataSent'
  /**
   * Binds to message events on the given `observer` to generate stats
   * based on the Peer, Protocol and Transport used for the message. Stat
   * events will be emitted via the `update` event.
   *
   * @param {Observer} observer
   * @param {any} _options
   * @returns {Stats}
   */

};

module.exports = function (observer, _options) {
  var options = Object.assign({}, defaultOptions, _options);
  var globalStats = new Stat(initialCounters, options);
  var stats = Object.assign(new EventEmitter(), {
    stop: stop,
    global: globalStats,
    peers: function peers() {
      return Array.from(peerStats.keys());
    },
    forPeer: function forPeer(peerId) {
      return peerStats.get(peerId) || oldPeers.get(peerId);
    },
    transports: function transports() {
      return Array.from(transportStats.keys());
    },
    forTransport: function forTransport(transport) {
      return transportStats.get(transport);
    },
    protocols: function protocols() {
      return Array.from(protocolStats.keys());
    },
    forProtocol: function forProtocol(protocol) {
      return protocolStats.get(protocol);
    }
  });
  globalStats.on('update', propagateChange);
  var oldPeers = OldPeers(options.maxOldPeersRetention);
  var peerStats = new Map();
  var transportStats = new Map();
  var protocolStats = new Map();
  observer.on('message', function (peerId, transportTag, protocolTag, direction, bufferLength) {
    var event = directionToEvent[direction];

    if (transportTag) {
      // because it has a transport tag, this message is at the global level, so we account this
      // traffic as global.
      globalStats.push(event, bufferLength); // peer stats

      var peer = peerStats.get(peerId);

      if (!peer) {
        peer = oldPeers.get(peerId);

        if (peer) {
          oldPeers.delete(peerId);
        } else {
          peer = new Stat(initialCounters, options);
        }

        peer.on('update', propagateChange);
        peer.start();
        peerStats.set(peerId, peer);
      }

      peer.push(event, bufferLength);
    } // transport stats


    if (transportTag) {
      var transport = transportStats.get(transportTag);

      if (!transport) {
        transport = new Stat(initialCounters, options);
        transport.on('update', propagateChange);
        transportStats.set(transportTag, transport);
      }

      transport.push(event, bufferLength);
    } // protocol stats


    if (protocolTag) {
      var protocol = protocolStats.get(protocolTag);

      if (!protocol) {
        protocol = new Stat(initialCounters, options);
        protocol.on('update', propagateChange);
        protocolStats.set(protocolTag, protocol);
      }

      protocol.push(event, bufferLength);
    }
  });
  observer.on('peer:closed', function (peerId) {
    var peer = peerStats.get(peerId);

    if (peer) {
      peer.removeListener('update', propagateChange);
      peer.stop();
      peerStats.delete(peerId);
      oldPeers.set(peerId, peer);
    }
  });
  return stats;

  function stop() {
    globalStats.stop();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = peerStats.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var peerStat = _step.value;
        peerStat.stop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = transportStats.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var transportStat = _step2.value;
        transportStat.stop();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  function propagateChange() {
    stats.emit('update');
  }
};